module.exports = __webpack_public_path__ + "static/img/sx-ypt.864be7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/case/sx-ypt.jpg
// module id = 12s8
// module chunks = 1